export const excludeMenuList = ['online-course', 'notify', 'blog', 'student-blog', 'video', 'enquiry'];